<template>
  <section class="individual_speakers">
    <div class="container-row">
      <div class="indivdual_speaker-main-wrapper">
        <div class="individual_speaker-content-wrapper">
        
              <div class="individual_speaker-image">
                <picture>
                <img
                v-if="avatar === 'https://www.dmgeventsconferences.com/'"
                src="https://www.egyptminingforum.com/media/jnoeomny/speakerdefault.png?mode=crop&width=298&height=298"
                alt="Default Avatar 300x300"
                class="img-fluid"
              />
              <img
                v-else-if="!avatar"
                src="https://www.egyptminingforum.com/media/jnoeomny/speakerdefault.png?mode=crop&width=298&height=298"
                alt="Default Avatar 300x300"
                class="img-fluid"
              />
              <img
                v-else
                :src="`${avatar}?mode=crop&width=298&height=298`"
                alt="User Avatar 300x300"
                class="img-fluid"
              />
              </picture>
              </div>
              <div class="individual_speaker-text">
                <h2>{{ name }}</h2>
                <h5>
                  {{ jobTitle }}
                </h5>
                <h5>{{ company }}</h5>
              </div>
        </div>
           
            <div class="speaker-bio" v-if="biography">
              <p>{{ biography }}</p>
          </div>
          <div class="individual_speaker-button-wrapper">
          <div class="btn-secondary">
            <button @click="goBack">BACK TO ALL 2024 SPEAKERS</button>
          </div>
        </div>
      </div>
    </div>
  
</section>
</template>
<script>
//import $ from 'jquery';
import axios from "axios";
import url from "./../../config/url";
export default {
  name: "ExhibitorProfilePage",
  data: function() {
    return {
      exhibitorid: this.$route.query.userId,
      id: null,
      name: null,
      jobTitle: null,
      company: null,
      biography: null,
      avatar: null,
      country: null,
      companyLogo: null,
      eventname: "",
      sessions: null,
    };
  },
  mounted() {
    this.exhibitorDetails(this.exhibitorid);
    const url = window.location.href;
    const domain = url.split("/")[2];
    if (domain === "www.futureenergyasia.com") {
      this.eventname = "fea";
    } else if (domain === "www.future-mobility.asia") {
      this.eventname = "fma";
    } else if (domain === "www.japanenergyevent.com/") {
      this.eventname = "japan";
    } else if (domain === "www.gastechevent.com") {
      this.eventname = "gastech";
    } else {
      this.eventname = "fea";
    }
     // Store the current page URL in cookies
     this.setCookie("previousPage", document.referrer || "/forum-programme/2024-speakers");
  },
  methods: {
    exhibitorDetails: function(eId) {
      // debugger
      axios
        .get(url.user_detail_api, { params: { Userid: eId } })
        .then((response) => {
          //    debugger
          this.id = response.data[0].id;
          this.name = response.data[0].name;
          this.jobTitle = response.data[0].jobTitle;
          this.company = response.data[0].company;
          this.biography = response.data[0].biography;
          this.avatar = response.data[0].avatar;
          this.country = response.data[0].country;
          this.companyLogo = response.data[0].companyLogo;
          this.sessions = response.data[0].sessions;
        })
        .catch((error) => {
          console.log(error);
        });
      window.scrollTo(0, 0);
    },
    goBack() 
    {
      // Check if a previous page URL is stored in cookies
      const previousPage = this.getCookie("previousPage");
      if (previousPage) {
        // Navigate to the stored page
        window.location.href = previousPage;
      }
      else{
         // Default to the listing page if no previous page is found
         this.$router.push("/forum-programme/2024-speakers");
      }
    },

    getCookie(name) {
      // Helper function to get a cookie by name
      const cookies = document.cookie.split("; ");
      for (const cookie of cookies) {
        const [key, value] = cookie.split("=");
        if (key === name) {
          return decodeURIComponent(value);
        }
      }
      return null;
    },
    setCookie(name, value, days = 1) {
      // Helper function to set a cookie
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${encodeURIComponent(value)};expires=${date.toUTCString()};path=/`;
    },
    exhibitorProductData: function() {
      (this.showProductCategory = true),
        (this.showPressRelease = false),
        (this.showBrochure = false);
    },
    exhibitorPressReleaseData: function() {
      (this.showProductCategory = false),
        (this.showPressRelease = true),
        (this.showBrochure = false);
    },
    exhibitorBrochuresData: function() {
      (this.showProductCategory = false),
        (this.showPressRelease = false),
        (this.showBrochure = true);
    },
  },
};
</script>
